import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SharedModule } from "../../../shared/shared.module";
import { ExportPdfButtonComponent } from "./export-pdf-button.component";

@NgModule({
    imports: [
        CommonModule,
        SharedModule
    ],
    exports: [
        ExportPdfButtonComponent
    ],
    declarations: [
        ExportPdfButtonComponent
    ]
})
export class ExportPdfButtonModule { }